<div class="sticky-header">
	<div #static class="info-box flex flex-row">
		<div
			class="info-container flex flex-row flex-gap"
			style="--gap: 15px"
			[ngStyle]="{ 'min-width': minWidth + 'px', 'max-width': minWidth + 'px' }"
			[attr.data-test]="expandMilestoneGroupWithName === 'NETS' ? 'head-count-card' : 'subservice-count-card'"
		>
			<div class="headcount-thumb">
				<app-icon
					[name]="'profile-2user'"
					[color]="'var(--color-text-default)'"
					[size]="'35'"
					[lineWidth]="'1.5px'"
				></app-icon>
			</div>

			<div class="flex flex-column">
				<span class="title">{{
					expandMilestoneGroupWithName === "NETS" ? "Headcount" : "Subservice Count"
				}}</span>
				<div
					*ngIf="!updating && milestoneReport"
					class="value-container flex flex-row flex-gap"
					style="--gap: 5px"
				>
					<span
						class="value"
						[ngPlural]="milestoneReport.totalHeadCount"
						[attr.data-test]="
							expandMilestoneGroupWithName === 'NETS'
								? 'head-count-card-value'
								: 'subservice-count-card-value'
						"
					>
						{{ milestoneReport.totalHeadCount }}
						<ng-template ngPluralCase="=0">{{
							expandMilestoneGroupWithName === "NETS" ? "Employees" : "Subservices"
						}}</ng-template>
						<ng-template ngPluralCase="=1">{{
							expandMilestoneGroupWithName === "NETS" ? "Employee" : "Subservice"
						}}</ng-template>
						<ng-template ngPluralCase="other">{{
							expandMilestoneGroupWithName === "NETS" ? "Employees" : "Subservices"
						}}</ng-template>
					</span>
				</div>
				<span class="value" *ngIf="updating">Calculating...</span>
			</div>
		</div>
		<div
			class="info-container flex flex-row flex-gap"
			style="--gap: 15px"
			[ngStyle]="{ 'min-width': minWidth + 'px', 'max-width': minWidth + 'px' }"
			[attr.data-test]="'transactions-card'"
		>
			<div class="transactions-thumb">
				<app-icon
					[name]="'money-change'"
					[color]="'var(--color-text-default)'"
					[size]="'35'"
					[lineWidth]="'1.5px'"
				></app-icon>
			</div>
			<div class="flex flex-column">
				<span class="title">Transactions</span>
				<div
					*ngIf="!updating && milestoneReport"
					class="value-container flex flex-row flex-gap"
					style="--gap: 5px"
				>
					<span class="value" [attr.data-test]="'transactions-card-value'"
						>{{ milestoneReport.totalTransactionCount }}

						<span
							class="value-failed"
							*ngIf="milestoneReport.failedTransactionCount > 0"
							[attr.data-test]="'transactions-card-failed-value'"
							>({{ milestoneReport.failedTransactionCount }} failed)</span
						>
					</span>
				</div>
				<span class="value" *ngIf="updating">Calculating...</span>
			</div>
		</div>
		<div
			class="info-container flex flex-row flex-gap"
			style="--gap: 15px"
			[attr.data-test]="'total-payments-card'"
			#payment
		>
			<div class="payments-thumb">
				<app-icon
					[name]="'receipt-add'"
					[color]="'var(--color-text-default)'"
					[size]="'35'"
					[lineWidth]="'1.5px'"
				></app-icon>
			</div>
			<div class="flex flex-column">
				<span class="title">Total Payments</span>
				<div class="flex flex-row flex-gap" style="--gap: 5">
					<div
						*ngIf="!updating && milestoneReport"
						class="value-container flex flex-row flex-gap"
						style="--gap: 5px"
					>
						<span class="value" [attr.data-test]="'total-payments-card-value'"
							>{{ milestoneReport.totalPayoutAmount.value
							}}{{ milestoneReport.totalPayoutAmount.currency | currencySymbol }}</span
						>
						<span
							class="value-failed"
							*ngIf="milestoneReport.totalFailedAmount.value > 0"
							[attr.data-test]="'total-payments-card-failed-value'"
						>
							({{ milestoneReport.totalFailedAmount.value
							}}{{ milestoneReport.totalFailedAmount.currency | currencySymbol }})</span
						>
					</div>
					<span class="value" *ngIf="updating">Calculating...</span>
				</div>
			</div>
		</div>
		@if (this.isCPNowDeductionsEnabled) {
		<div
			class="info-container flex flex-row flex-gap"
			style="--gap: 15px"
			[attr.data-test]="'total-deduction-card'"
			#payment
		>
			<div class="deduction-thumb">
				<app-icon
					[name]="'receipt-subtract'"
					[color]="'var(--color-text-default)'"
					[size]="'35'"
					[lineWidth]="'1.5px'"
				></app-icon>
			</div>
			<div class="flex flex-column">
				<span class="title">Total Deductions</span>
				<div class="flex flex-row flex-gap" style="--gap: 5">
					<div
						*ngIf="!updating && milestoneReport"
						class="value-container flex flex-row flex-gap"
						style="--gap: 5px"
					>
						<span class="value" [attr.data-test]="'total-deduction-card-value'"
							>{{ milestoneReport.totalDeductionAmount.value
							}}{{ milestoneReport.totalDeductionAmount.currency | currencySymbol }}</span
						>
					</div>
					<span class="value" *ngIf="updating">Calculating...</span>
				</div>
			</div>
		</div>
		}
	</div>
</div>
